import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mb-4" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "row mb-4 justify-content-md-center" }
const _hoisted_5 = { class: "col-md-8" }
const _hoisted_6 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[7] || (_cache[7] = _createElementVNode("label", {
          for: "priceWindowName",
          class: "form-label"
        }, "Price Window Name", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: _normalizeClass({ 'form-control': true, 'form-control-error': _ctx.invalidName }),
          id: "priceWindowName",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nameValue) = $event)),
          onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.checkInvalidName && _ctx.checkInvalidName(...args)))
        }, null, 34), [
          [_vModelText, _ctx.nameValue]
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("label", {
          for: "priceWindowDescription",
          class: "form-label"
        }, "Price Window Description", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          id: "priceWindowDescription",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.descriptionValue) = $event))
        }, null, 512), [
          [_vModelText, _ctx.descriptionValue]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[9] || (_cache[9] = _createElementVNode("span", { for: "daysRange" }, "For reservations", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "number",
            min: "0",
            max: "9999",
            class: _normalizeClass({
            'form-control': true,
            'me-2 ': true,
            'daysRange-input': true,
            'form-control-error': _ctx.invalidDaysIn || _ctx.daysInMoreThanDayOut,
          }),
            id: "daysRangeStart",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.daysInValue) = $event)),
            placeholder: "0",
            onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.checkInvalidDaysIn && _ctx.checkInvalidDaysIn(...args)))
          }, null, 34), [
            [
              _vModelText,
              _ctx.daysInValue,
              void 0,
              { number: true }
            ]
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("span", { class: "me-2" }, "to", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "number",
            min: "0",
            max: "9999",
            class: _normalizeClass({
            'form-control': true,
            'me-2 ': true,
            'daysRange-input': true,
            'form-control-error': _ctx.invalidDaysOut || _ctx.daysInMoreThanDayOut,
          }),
            id: "daysRangeEnd",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.daysOutValue) = $event)),
            placeholder: "9999",
            onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.checkInvalidDaysOut && _ctx.checkInvalidDaysOut(...args)))
          }, null, 34), [
            [
              _vModelText,
              _ctx.daysOutValue,
              void 0,
              { number: true }
            ]
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("span", null, "days before a tee time, this pricing logic will be used.", -1))
        ])
      ])
    ])
  ], 64))
}